import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";

import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Conversations from "./pages/Conversations";
import ConversationDetail from "./pages/ConversationDetail";
import AlphaConversationDetail from "./pages/AlphaConversationDetail";
import Analytics from "./pages/Analytics";
import KMSReferences from "./pages/KMSReferences";
import KMSGaps from "./pages/KMSGaps";
import AIAssistant from "./pages/AIAssistant";
import UserManagement from "./pages/UserManagement";
import AuditLog from "./pages/AuditLog";
import LoggedOut from "./pages/LoggedOut";
import UserSessions from "./pages/UserSessions";
import UserSessionsList from "./pages/UserSessionsList";
import AnswerDetailClicks from "./pages/AnswerDetailClicks";

const guarded = (perm, El) => (
  <ProtectedRoute permission={perm}>
    <Layout>
      <El />
    </Layout>
  </ProtectedRoute>
);

function BrowserTitle() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const titleMap = [
      { match: (value) => value === "/", title: "Dashboard" },
      { match: (value) => value === "/conversations", title: "Beta Tester" },
      { match: (value) => value.startsWith("/conversations/"), title: "Conversation Details" },
      { match: (value) => value === "/analytics", title: "Analytics" },
      { match: (value) => value.startsWith("/detailed-answer-clicks"), title: "Detailed Answer Clicks" },
      { match: (value) => value === "/sessions", title: "Alpha Tester" },
      { match: (value) => value.startsWith("/sessions/"), title: "Session Details" },
      { match: (value) => value === "/kms", title: "KMS Library" },
      { match: (value) => value === "/kms/gaps", title: "KMS Gaps" },
      { match: (value) => value === "/assistant", title: "AI Assistant" },
      { match: (value) => value === "/users", title: "User Management" },
      { match: (value) => value === "/audit", title: "Audit Log" },
      { match: (value) => value === "/logged-out", title: "Logged Out" },
      { match: (value) => value === "/auth/callback", title: "Authentication" },
    ];

    const match = titleMap.find((item) => item.match(path));
    document.title = match ? `Dyanakosh | ${match.title}` : "Dyanakosh";
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}

export default function App() {
  return (
    <>
      <BrowserTitle />
      <Routes>
      {/* Public OAuth Callback - 
          This is where the BFF redirects after successful SSO 
      */}
      <Route path="/logged-out" element={<LoggedOut />} />
      <Route path="/auth/callback" element={<AuthCallback />} />

      {/* Authenticated routes: Layout and Permission Gated */}
      <Route path="/" element={guarded("analytics:read", Dashboard)} />
      <Route
        path="/conversations"
        element={guarded("conversations:read", Conversations)}
      />
      <Route
        path="/conversations/:id"
        element={guarded("conversations:read", ConversationDetail)}
      />
      <Route
        path="/alpha-conversations/:id"
        element={guarded("conversations:read", AlphaConversationDetail)}
      />
      <Route path="/analytics" element={guarded("analytics:read", Analytics)} />
      <Route path="/detailed-answer-clicks" element={guarded("conversations:read", AnswerDetailClicks)} />
      <Route path="/detailed-answer-clicks/:userId" element={guarded("conversations:read", AnswerDetailClicks)} />
      <Route path="/sessions" element={guarded("analytics:read", UserSessions)} />
      <Route path="/kms" element={guarded("kms:read", KMSReferences)} />
      <Route path="/kms/gaps" element={guarded("kms:read", KMSGaps)} />
      <Route path="/sessions/user/:userId" element={guarded("analytics:read", UserSessionsList)} />
<Route path="/sessions/conversation/:id" element={guarded("conversations:read", AlphaConversationDetail)} />
      <Route
        path="/assistant"
        element={guarded("assistant:use", AIAssistant)}
      />
      <Route path="/users" element={guarded("users:read", UserManagement)} />
      <Route path="/audit" element={guarded("audit:read", AuditLog)} />

      {/* Fallback — Redirects back to Dashboard (which triggers Login if needed) */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  );
}
